export const playCompleteSound = (src) => {
  const audio = new Audio(src);
  audio.currentTime = 0; // restart if already played
  audio.play().catch((err) => {
    console.warn("Audio playback failed:", err);
  });
};
